import { c as _c } from "react/compiler-runtime";
import { TourCardCarouselHookPropertiesType, TourCardCarouselSideType } from "@website/accommodation-ui/tour-card/tour-card-carousel/types";
import { useState } from "react";
export const useTourCardCarousel = t0 => {
  const $ = _c(5);
  const {
    thumbnails
  } = t0;
  const t1 = thumbnails?.length;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      length: t1,
      currentIndex: 0
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [carousel, setCarousel] = useState(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = side => {
      setCarousel(previous => ({
        ...previous,
        currentIndex: side === "next" ? previous.currentIndex > 0 ? previous.currentIndex - 1 : previous.length - 1 : previous.currentIndex < previous.length - 1 ? previous.currentIndex + 1 : 0
      }));
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleChangeImage = t3;
  let t4;
  if ($[3] !== carousel) {
    t4 = {
      carousel,
      handleChangeImage
    };
    $[3] = carousel;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};